import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class HelperService {
  constructor() {}

  createArray(cantElements: number) {
    return Array.from(new Array(cantElements), (x, i) => i + 1);
  }

  getAmountOfPages(registers: any, pageLimit: number) {
    return registers > 0 ? Math.ceil(parseInt(registers || 1) / pageLimit) : 1;
  }

  restrict($event: any) {
    // Estos son los códigos de las teclas que son presionadas.
    const arrayCodes = [8, 9, 37, 39, 46];
    if (
      $event.keyCode === 91 ||
      $event.keyCode === 88 ||
      $event.keyCode === 67 ||
      $event.keyCode === 86 ||
      $event.keyCode === 13
    ) {
      return;
    } else if (
      arrayCodes.indexOf($event.keyCode) === -1 &&
      $event.key.search(/\d\b/) === -1
    ) {
      $event.preventDefault();
    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }
}
